"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoSaveIndicator = AutoSaveIndicator;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const Css_1 = require("../Css");
const types_1 = require("../types");
const _1 = require(".");
const Icon_1 = require("./Icon");
function AutoSaveIndicator({ hideOnIdle, doNotReset }) {
    const { status, resetStatus, errors } = (0, _1.useAutoSaveStatus)();
    (0, react_1.useEffect)(() => {
        if (doNotReset)
            return;
        /**
         * Any time AutoSaveIndicator dismounts, most likely on Page Navigation,
         * state should clear before the next Indicator mounts
         */
        return () => resetStatus();
    }, 
    // TODO: validate this eslint-disable. It was automatically ignored as part of https://app.shortcut.com/homebound-team/story/40033/enable-react-hooks-exhaustive-deps-for-react-projects
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    switch (status) {
        case _1.AutoSaveStatus.IDLE:
            return hideOnIdle ? null : (0, jsx_runtime_1.jsx)(Indicator, { icon: "cloudSave" });
        case _1.AutoSaveStatus.SAVING:
            return (0, jsx_runtime_1.jsx)(Indicator, { icon: "refresh", text: "Saving..." });
        case _1.AutoSaveStatus.DONE:
            return (0, jsx_runtime_1.jsx)(Indicator, { icon: "cloudSave", text: "Saved" });
        case _1.AutoSaveStatus.ERROR:
            return (
            /**
             * Tooltip is expanding to fill as much available space as it can, possibly
             * rendering it far away from the Icon/Text. Wrap it with a div to constrain
             * it.
             */
            (0, jsx_runtime_1.jsx)("div", { css: Css_1.Css.dif.$, children: (0, jsx_runtime_1.jsx)(_1.Tooltip, { title: String(errors), placement: "bottom", children: (0, jsx_runtime_1.jsx)(Indicator, { icon: "error", color: Css_1.Palette.Red500, text: "Error saving" }) }) }));
        default:
            (0, types_1.assertNever)(status);
    }
}
function Indicator({ text, icon, color }) {
    return ((0, jsx_runtime_1.jsxs)("div", { "data-testid": "autoSave", css: Css_1.Css.df.gap1.aic.gray700.smMd.$, children: [(0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: icon, color: color }), text] }));
}
